import { Response } from "miragejs";

/**
 * All the routes related to Videos are present here.
 * These are Publicly accessible routes.
 * */

/**
 * This handler handles gets all videos in the db.
 * send GET Request at /api/videos
 * */

export const getAllVideosHandler = function () {
	try {
		return new Response(200, {}, { videos: this.db.videos });
	} catch (error) {
		return new Response(
			500,
			{},
			{
				error,
			}
		);
	}
};

/**
 * This handler handles uploads a new video to the db.
 * send POST Request at /api/user/videos/
 * */

// TODO: postVideoHandler

/**
 * This handler handles gets all videos in the db.
 * send GET Request at /api/user/videos/:videoId
 * */

export const getVideoHandler = function (schema, request) {
	const { videoId } = request.params;
	try {
		const video = schema.videos.findBy({ _id: videoId }).attrs;
		return new Response(200, {}, { video });
	} catch (error) {
		return new Response(
			500,
			{},
			{
				error,
			}
		);
	}
};

/**
 * This handler handles adding videos to user's likes.
 * send POST Request at /api/user/likes
 * body contains {video}
 * */

export const updateVideoHandler = function (schema, request) {
	const { videoId } = request.params;
	try {
		const { comment } = JSON.parse(request.requestBody);
		const updatedVideos = this.db.videos.reduce(
			(prev, curr) =>
				curr._id === videoId
					? [
							...prev,
							{
								...curr,
								comments: [...curr.comments, { ...comment }],
							},
					  ]
					: [...prev, { ...curr }],
			[]
		);
		this.db.videos.update(updatedVideos);
		return new Response(200, {}, { videos: updatedVideos });
	} catch (error) {
		return new Response(
			500,
			{},
			{
				error,
			}
		);
	}
};
